import type { User } from '@supabase/supabase-js';

import type { TPersona } from 'constants/navigation';
import { PERSONAS } from 'constants/navigation';

import type { TAdminAccount, TStaffSession } from './auth.types';

type TSessionPayload = {
  next_step?: unknown;
  sub_role?: unknown;
  factor_id?: unknown;
};

const STEP_STAGES = ['mfa_enroll', 'mfa_verify', 'ready'] as const;

const toAdminAccount = (user: User): TAdminAccount => ({
  userID: user.id,
  email: user.email ?? '',
});

const toPersona = (value: unknown): TPersona | null => ((PERSONAS as readonly string[]).includes(value as string) ? (value as TPersona) : null);

const toStaffSession = (payload: TSessionPayload, email: string): TStaffSession | null => {
  const step = STEP_STAGES.find(candidate => candidate === payload.next_step);

  if (!step) {
    return null;
  }

  return {
    stage: step,
    email,
    subRole: toPersona(payload.sub_role),
    factorID: typeof payload.factor_id === 'string' ? payload.factor_id : null,
  };
};

export type {
  TSessionPayload,
};
export {
  toAdminAccount,
  toStaffSession,
};
